/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { staticListHeaderStyles } from "@monsma/Overrides/Widgets/StaticList/StaticListHeader";
import { css } from "styled-components";

staticListHeaderStyles.infoGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

staticListHeaderStyles.addListToCartButton = {
    css: css`
        margin-left: 10px;
    `,
};

staticListHeaderStyles.listNameTextField = {};

staticListHeaderStyles.cancelButton = {
    sizeVariant: "medium",
    variant: "secondary",
};

staticListHeaderStyles.saveButton = {
    sizeVariant: "medium",
    css: css`
        margin-left: 10px;
    `,
};

(staticListHeaderStyles as any).smallHidden = {
    below: "md",
};

(staticListHeaderStyles as any).actionsGridItem = {
    width: [2, 2, 6, 4, 4],
    css: css`
        justify-content: flex-end;
    `,
};

staticListHeaderStyles.descriptionText = {
    css: css`
        margin-bottom: 30px;
    `,
};

(staticListHeaderStyles as any).titleGridItem = {
    width: [8, 8, 6, 8, 8],
};

(staticListHeaderStyles as any).wideHidden = {
    above: "sm",
    css: css`
        display: flex;
        flex-wrap: nowrap;
    `,
};

(staticListHeaderStyles as any).saveListBtnGridItem = {
    width: 4,
    css: css`
        justify-content: flex-end;
    `,
};
